






























































































































































































































































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import CopyText from '@/components/misc/CopyText.vue'
import { toDCM } from '@/helper'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK_NAME,
    HAS_SUBNET,
} from '@/store/modules/network/network'

@Component({
    components: {
        Tooltip,
        CopyText,
    },
    filters: {},
})
export default class EVMMetadata extends Vue {
    @Prop() block!: EVMBlockQueryResponse
    moreDetails = false

    // forTSP = false
    // created() {
    //     if (
    //         window.location.href.includes('blockchain') ||
    //         localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    get latestBlockNumber() {
        return localStorage.getItem('latestBlock')
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get date(): Date {
        return new Date(parseInt(this.block.header.timestamp))
    }

    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }

    get gas() {
        return (
            (parseInt(this.block.header.gasUsed) /
                parseInt(this.block.header.gasLimit)) *
            100
        )
    }

    get baseFeePerGas() {
        return toDCM(this.block.header.baseFeePerGas, 9)
    }

    toggleMore() {
        this.moreDetails = !this.moreDetails
    }
}
